export default __webpack_public_path__ + "play.84a30269.svg";